import React, { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";

// Vendor Insight Dashboard
const VendorInsight = () => {
  const [activeTab, setActiveTab] = useState("marketplace-seller-overview");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "marketplace-seller-overview":
        return (
          <GetKibanaDashboard dashboardKey={"Marketplace Seller Overview"} />
        );
      case "aws_marketplace_offers_insight":
        return (
          <GetKibanaDashboard dashboardKey={"aws_marketplace_offers_insight"} />
        );
      case "agreements":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Seller Disbursement Insights"} />
        );
      case "billed-revenue":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Billing"} />
        );
      case "collections":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Collection And Disbursment"} />
        );
      case "AWS_Marketplace_others":
        return (
          <GetKibanaDashboard dashboardKey={"AWS_Marketplace_others"} />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Marketplace Seller Overview" value="marketplace-seller-overview" />
        <Tab label="Offers" value="aws_marketplace_offers_insight" />
        <Tab label="Agreements and Renewals" value="agreements" />
        <Tab label="Undisbursed" value="billed-revenue" />
        <Tab label="Disbursed" value="collections" />
        <Tab label="Others" value="AWS_Marketplace_others" />
      </Tabs>
      {renderTabContent()}
    </div>
  );
};

export default VendorInsight;
